import React from 'react';
import { motion } from 'framer-motion';
import { EbookMockup } from './EbookMockup';
const bonuses = [{
  title: '100 HOOKS VIRALES',
  subtitle: 'LISTOS PARA USAR',
  value: '$47',
  desc: 'Ganchos probados para capturar la atención en los primeros 3 segundos de tus Reels y TikToks.',
  image: 'https://cdn.magicpatterns.com/uploads/67uWSgkt7btrswc64XxH1q/100_HOOKS_VIRALES_COVER.png'
}, {
  title: '30 DÍAS DE CONTENIDO',
  subtitle: 'PARA INSTAGRAM',
  value: '$97',
  desc: 'Un calendario exacto con qué publicar cada día para crecer y vender sin estrés.',
  image: 'https://cdn.magicpatterns.com/uploads/g2qhYo4EgNBp9bekFphQ55/30_DIAS_DE_CONTENIDO_IF_COVER.png'
}, {
  title: 'HAZ QUE LA IA',
  subtitle: 'SUENE COMO TÚ',
  value: '$67',
  desc: 'El framework secreto para entrenar a ChatGPT con tu tono de voz y personalidad.',
  image: 'https://cdn.magicpatterns.com/uploads/9AsDgGXSCwHFeMYUuuHuFM/HAS_QUE_LA_IA_SUENE_COMO_TU_COVER.png'
}];
export function Bonuses() {
  return <section id="bonos" className="py-24 md:py-32 relative border-y border-gold/10 bg-black-100/50 overflow-hidden" data-id="element-16">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-gold-glow opacity-30 pointer-events-none" data-id="element-17"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20 md:mb-32" data-id="element-19">
          <h2 className="font-display text-4xl md:text-5xl text-cream mb-6" data-id="element-20">
            Tus 3 bonos premium incluidos
          </h2>
          <p className="text-cream/60 max-w-2xl mx-auto text-lg font-light" data-id="element-21">
            Llévate estas 3 guías exclusivas completamente gratis al adquirir La
            Biblia hoy.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8" data-id="element-22">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="flex flex-col items-center text-center group" data-id="element-23">
              <div className="mb-12 relative" data-id="element-24">
                <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700" data-id="element-25"></div>
                <EbookMockup title={bonus.title} subtitle={bonus.subtitle} className="max-w-[280px] md:max-w-[340px] lg:max-w-[380px]" tilt={-10} delay={idx * 0.2} image={bonus.image} data-id="element-26" />
              </div>

              <div className="inline-flex items-center gap-2 mb-4" data-id="element-27">
                <span className="text-cream/40 line-through text-sm" data-id="element-28">
                  Valor: $19
                </span>
                <span className="bg-gold/10 text-gold border border-gold/20 px-2 py-0.5 rounded text-[10px] uppercase tracking-widest" data-id="element-29">
                  Incluido Gratis
                </span>
              </div>

              <h3 className="text-xl font-display text-cream mb-3" data-id="element-30">
                Bono 0{idx + 1}
              </h3>
              <p className="text-cream/60 font-light text-sm max-w-xs leading-relaxed" data-id="element-31">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}